import { ISocialFeed, PublicPostTypes, FormSubmissionTypes, SocialFeedsSources } from '../types/SocialFeed';
import { PostType, IPost } from '../types/Post';
import { Nullable } from '../types/Typescript-utils';

export interface IPublicPostOptions {
  email: boolean;
  custom_field: boolean;
  multiple_files: boolean | undefined;
  form_id?: number;
  form_team_id?: number;
}

export interface IReviewsOptions {
  email: boolean;
  author_name: boolean;
  media_url: boolean;
  multiple_files: boolean | undefined;
  form_id?: number;
  form_team_id?: number;
}

export type SocialFeedsTypesMap<T> = {
  [types in PostType]?: T;
};

export interface ICommonOptions {
  [key: string]: boolean;
}

interface ISocialFeedsGroupedItemCommon {
  name: string;
  id: number;
}

export interface ISocialFeedsGroupedItem extends ISocialFeedsGroupedItemCommon {
  options: Nullable<ICommonOptions>;
}

export interface ISocialFeedsPublicPost extends ISocialFeedsGroupedItemCommon {
  options: Nullable<IPublicPostOptions>;
}

export interface ISocialFeedsReviews extends ISocialFeedsGroupedItemCommon {
  options: Nullable<IReviewsOptions>;
}

export const serializeSocialFeeds = (
  socialFeeds: readonly ISocialFeed[]
): SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]> =>
  socialFeeds.reduce(
    (
      acc: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>,
      { attributes: { source, name, options, type }, id }: ISocialFeed
    ) => {
      const isReviewsRatingsSocialFeed = source === SocialFeedsSources.PUBLIC_POST && type === PublicPostTypes.REVIEWS;
      const isFormSocialFeed = source === SocialFeedsSources.FORM_SUBMISSION && type === FormSubmissionTypes.FORM;

      const sourceName = isReviewsRatingsSocialFeed
        ? PublicPostTypes.REVIEWS
        : isFormSocialFeed
        ? FormSubmissionTypes.FORM
        : source;

      if (acc[sourceName] === undefined) {
        return { ...acc, [sourceName]: [{ name, id, options }] };
      } else {
        return { ...acc, [sourceName]: [...acc[sourceName], { name, id }] };
      }
    },
    {}
  );

export const mergePostsWithSocialFeedType = (
  posts: IPost[],
  socialFeeds?: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>
): IPost[] => {
  return posts.map(post => {
    if (socialFeeds) {
      const type = Object.keys(socialFeeds).find(key =>
        socialFeeds[key].find(e => e.id === post.relationships.social_feed.data.id)
      ) as PostType;

      return {
        ...post,
        ...{
          attributes: {
            ...post.attributes,
            type,
          },
        },
      };
    } else {
      return post;
    }
  });
};
